

<head>
  <!-- Required meta tags -->
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">

  <!-- Bootstrap CSS -->
  <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/css/bootstrap.min.css"
    integrity="sha384-Vkoo8x4CGsO3+Hhxv8T/Q5PaXtkKtu6ug5TOeNV6gBiFeWPGFN9MuhOf23Q9Ifjh" crossorigin="anonymous">
</head>


  <div class="container-fluid">
    <div class="row">
          <h5 class="border-bottom">Master Policies</h5>
          <nav class="navbar navbar-light bg-light justify-content-between">
            <a class="navbar-brand"></a>
            <div class="input-group search-style">
              <input  class="form-control mr-sm-1" type="search" [(ngModel)]="searchTerm"
                placeholder="Search">
              <div class="input-group-append">
                <button class="btn removefocus" type="button" (click)="search()" *ngIf="!isSearching">
                  <i class="fa fa-search"></i>
                </button>
                <button class="btn removefocus" type="button" (click)="clearSearch()" *ngIf="isSearching">
                  <i class="fa fa-times"></i>
                </button>

              </div>
            </div>
          </nav>

          <section class="table-container" [ngClass]="{ 'table-container-collapsed':!dynamicTabsService.isCollapsed}" tabindex="0">
            <table mat-table [dataSource]="dataSource" class="table table-bordered">
                 <ng-container matColumnDef="accountName">
                  <th mat-header-cell *matHeaderCellDef>
                    <button class="btn btn-link" (click)="sortData('accountName')" matTooltip="Sort by Insured">
                      Insured
                      <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='accountName'"
                        [class.fa-sort-asc]="sortingColumn ==='accountName' && sortOrder === 'asc'"
                        [class.fa-sort-desc]="sortingColumn ==='accountName' && sortOrder === 'desc'"></i>
                    </button>
                  </th>
                  <td mat-cell *matCellDef="let master">
                    <a (click)="sendIdtochild(master)">
                      {{master.accountName}}
                    </a>
                  </td>
                </ng-container>
                <ng-container matColumnDef="policyNumber">
                  <th mat-header-cell *matHeaderCellDef>
                    <button class="btn btn-link" (click)="sortData('policyNumber')" matTooltip="Sort by Policy Number">
                      Policy Number
                      <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='policyNumber'"
                        [class.fa-sort-asc]="sortingColumn ==='policyNumber' && sortOrder === 'asc'"
                        [class.fa-sort-desc]="sortingColumn ==='policyNumber' && sortOrder === 'desc'"></i>
                    </button>
                  </th>
                  <!-- <td mat-cell *matCellDef="let master" (click)="openPolicy(master)">{{ master.policyNumber}}</td> -->
                  <td mat-cell *matCellDef="let master">
                    <a (click)="openPolicy(master)">
                      {{master.policyNumber}}
                    </a>
                  </td>
                </ng-container>
                <ng-container matColumnDef="policyType">
                  <th mat-header-cell *matHeaderCellDef>
                    <button class="btn btn-link" (click)="sortData('policyType')" matTooltip="Sort by Policy Type">
                      Policy Type
                      <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='policyType'"
                        [class.fa-sort-asc]="sortingColumn ==='policyType' && sortOrder === 'asc'"
                        [class.fa-sort-desc]="sortingColumn ==='policyType' && sortOrder === 'desc'"></i>
                    </button>
                  </th>
                  <td mat-cell *matCellDef="let master">{{ master.policyType}}</td>
                </ng-container>
                <ng-container matColumnDef="policyStatus">
                  <th mat-header-cell *matHeaderCellDef>
                    <button class="btn btn-link" (click)="sortData('policyStatus')" matTooltip="Sort by Policy Status">
                      Policy Status
                      <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='policyStatus'"
                        [class.fa-sort-asc]="sortingColumn ==='policyStatus' && sortOrder === 'asc'"
                        [class.fa-sort-desc]="sortingColumn ==='policyStatus' && sortOrder === 'desc'"></i>
                    </button>
                  </th>
                  <td mat-cell *matCellDef="let master">{{ master.policyStatus}}</td>
                </ng-container>
                <ng-container matColumnDef="contractNumber">
                  <th mat-header-cell *matHeaderCellDef>
                    <button class="btn btn-link" (click)="sortData('contractNumber')" matTooltip="Sort by Contract">
                      Contract
                      <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='contractNumber'"
                        [class.fa-sort-asc]="sortingColumn ==='contractNumber' && sortOrder === 'asc'"
                        [class.fa-sort-desc]="sortingColumn ==='contractNumber' && sortOrder === 'desc'"></i>
                    </button>
                  </th>
                  <td mat-cell *matCellDef="let master">{{ master.contractNumber}}</td>
                </ng-container>
                <ng-container matColumnDef="effectiveDate">
                  <th mat-header-cell *matHeaderCellDef>
                    <button class="btn btn-link" (click)="sortData('effectiveDate')"
                      matTooltip="Sort by Effective Date">
                      Effective Date
                      <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='effectiveDate'"
                        [class.fa-sort-asc]="sortingColumn ==='effectiveDate' && sortOrder === 'asc'"
                        [class.fa-sort-desc]="sortingColumn ==='effectiveDate' && sortOrder === 'desc'"></i>
                    </button>
                  </th>
                  <td mat-cell *matCellDef="let master">{{ master.effectiveDate | date: 'MM/dd/yyyy'}}</td>
                </ng-container>
                <ng-container matColumnDef="expirationDate">
                  <th mat-header-cell *matHeaderCellDef>
                    <button class="btn btn-link" (click)="sortData('expirationDate')"
                      matTooltip="Sort by Expiration Date">
                      Expiration Date
                      <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='expirationDate'"
                        [class.fa-sort-asc]="sortingColumn ==='expirationDate' && sortOrder === 'asc'"
                        [class.fa-sort-desc]="sortingColumn ==='expirationDate' && sortOrder === 'desc'"></i>
                    </button>
                  </th>
                  <td mat-cell *matCellDef="let master">{{ master.expirationDate | date: 'MM/dd/yyyy' }}</td>
                </ng-container>
                <ng-container matColumnDef="notes">
                  <th mat-header-cell *matHeaderCellDef>
                    <button class="btn btn-link" (click)="sortData('notes')" matTooltip="Sort by Notes">
                      Notes
                      <i class="fa fa-fu" [class.fa-sort]="sortingColumn !=='notes'"
                        [class.fa-sort-asc]="sortingColumn ==='notes' && sortOrder === 'asc'"
                        [class.fa-sort-desc]="sortingColumn ==='notes' && sortOrder === 'desc'"></i>
                    </button>
                  </th>
                  <td mat-cell *matCellDef="let master">{{ master.notes}}
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="columnsToDisplay;sticky: true" class="headerstyle"></tr>
              <tr mat-row *matRowDef="let master; columns: columnsToDisplay"></tr>
            </table>
          </section>
      <!-- Pagination -->
      <div>
        <mat-paginator class="pagination" [length]="totalItems" [hidePageSize]="isHidePageSize"
        [showFirstLastButtons]="showFirstLastButtons" (page)="onPageChange($event)" aria-label="Select page">
        </mat-paginator>
      </div>
    </div>
       <!-- Table spinner -->
       <div *ngIf="isLoading" class="spinner-wrapper">
        <mat-spinner diameter="32" color="primary"></mat-spinner>
      </div>
  </div>
  
  
